const state = {
    UserItems: {
      data: [],
      total:0,
      pages: {
        page:1,
        totalPage : 1,
        limit:25,
        filter:{
          id : '',
          name: '',
          email: '',
          organization: '',
          phone : '',
          address_line : ''       
        }
      },
    },
    user : null,
    Loadings : {
      list : false
    }
  };
  
  const getters = {
    ListingUser: (state) => state.UserItems,
    Loadings : (state) => state.Loadings,
    IteamUser : (state) => state.user,
  };
  
  const actions = {
  
    async getListUser({commit}, params) {
      commit( 'setLoadings', {key:"list",val:true});
      return new Promise((resolve, reject) => {
        global.axios(`/api/users`, {
          method: "GET",
          params:params,
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
          response.data.data.pages = params
          commit( 'setLoadings', {key:"list",val:false});
          commit('setListingUser',response.data.data)
          resolve(response.data.data);
        })
        .catch(error => reject( error ));
      });
    },
    async getListUser2({commit}, params) {
      commit( 'setLoadings', {key:"list",val:true});
      return new Promise((resolve, reject) => {
        global.axios(`/api/users`, {
          method: "GET",
          params:params,
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
            commit( 'setLoadings', {key:"list",val:false});
          resolve(response.data.data);
        })
        .catch(error => {
            commit( 'setLoadings', {key:"list",val:false});
          reject( error )
        });
      });
    },
    async searchListUser({commit}, params) {
      commit( 'setLoadings', {key:"list",val:true});
      return new Promise((resolve, reject) => {
        global.axios(`/api/users`, {
          method: "GET",
          params: {
            limit  : params.limit || 50,
            page   : params.page || 1,
            filter : params.filters
          },
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
          let data = {
            data: response.data.data.items,
            total: response.data.data.total,
            currentPage: params.page,
            limit: params.limit || 50,
            filter: params.filters
          }
          commit( 'setLoadings', {key:"list",val:false});
          resolve(data);
        })
        .catch(error => reject( error ));
      });
    },
    async SaveUser({commit}, params) {
      commit( 'setLoadings', {key:"list",val:true});
      return new Promise((resolve, reject) => {
        global.axios(`/api/users`, {
          method: "POST",
          data: params,
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
            commit( 'setLoadings', {key:"list",val:false});
            commit('setUser',response.data.data)
            // commit( 'updateListingUser', response.data.data );
            resolve( response.data.data  );
        })
        .catch(error => {
          commit( 'setLoadings', {key:"list",val:false});
          reject( error.response.data )
        });
      });
    },
    async updateUser({commit}, params) {
      commit( 'setLoadings', {key:"list",val:true});
      return new Promise((resolve, reject) => {
        global.axios(`/api/users/${params.id}`, {
          method: "PUT",
          data: params,
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
            commit( 'setLoadings', {key:"list",val:false});
            commit( 'editListingUser', response.data.data );
            resolve( response.data.data );
        })
        .catch(error => {
          commit( 'setLoadings', {key:"list",val:false});
          reject( error.response.data )
        });
      });
    },
    async deleteUser({commit}, params) {
      commit( 'setLoadings', {key:"list",val:true});
      return new Promise((resolve, reject) => {
        global.axios(`/api/users`, {
          method: "DELETE",
          data:  {
            ids : params
          },
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
            commit( 'setLoadings', {key:"list",val:false});
            commit ( 'deleteUser', params)
            resolve( response );
        })
        .catch(error => reject( error ));
      });
    },
      async getUser({commit}, params) {
      return new Promise((resolve, reject) => {
        global.axios(`/api/users/${params}`, {
          method: "get",
          headers: {
              Accept: "application/json",
          }
        })
        .then(response => {
          commit('setItemUser', response.data.data)
          resolve( response );
        })
        .catch(error => reject( error ));
      });
    },
  };
  
  const mutations = {
    setListingUser (state,data) {
      data.pages.totalPage = Math.ceil(data.total / data.pages.limit );
      state.UserItems.data = data.items;
      state.UserItems.total = data.total;
      state.UserItems.pages = data.pages;
    },
    setItemUser(state, data) {
      state.user = data
    },
    updateListingUser (state,user) {
      state.UserItems.data = [...state.UserItems.data,user];
    },
    editListingUser (state,user) {
      if(state.UserItems.data) {
        state.UserItems.data = state.UserItems.data.map(item => item.id === user.id ? user : item)
      }
    },
    setLoadings (state,data) {
      if(data.key === "list"){
          state.Loadings.list = data.val;
      }
    },
    deleteUser(state,data) {
      state.UserItems.data =  state.UserItems.data.filter(function(obj) {
        return !data.some(function(obj2) {
          return obj.id == obj2;
        });
      });
    },
    setUser(state,data) {
      state.user = data;   
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }